import {Link} from "react-router-dom";
import {
    ClusterOutlined,
    CreditCardOutlined,
    DesktopOutlined,
    FileDoneOutlined,
    HistoryOutlined,
    MailOutlined,
    MessageOutlined,
    PieChartOutlined
} from "@ant-design/icons";
import {
    CalendarPlus,
    FileMinus2,
    FilePlus2,
    Handshake,
    Landmark,
    MonitorSmartphone,
    Users,
    CircleArrowDown,
    BookOpen,
    Box,
    LaptopMinimal,
    Smartphone
} from "lucide-react";
import {getItem} from "../SideBarItems";

const AdminSideBarItems = ({t}) => {
    return (
        [
            getItem(
                t('sideBar.items.column1'),
                'analysis_item',
                <Link to='/analysis'>
                    <PieChartOutlined/>
                </Link>
            ),
            getItem(
                t('sideBar.items.column2'),
                'devices_company_item',
                <Link to='/devices/company'>
                    <Landmark size={14}/>
                </Link>
            ),
            getItem(t("sideBar.items.column3"), 'devices_items', <FileDoneOutlined/>, [
                getItem(
                    t("sideBar.items.column1"),
                    'device_analysis_item',
                    <Link to='/devices/analysis'>
                        <PieChartOutlined size={14} color='#1e1e1e'/>
                    </Link>
                ),
                getItem(
                    t("sideBar.items.column15"),
                    'devices_status_item',
                    <Link to='/devices'>
                        <DesktopOutlined/>
                    </Link>
                ),
                getItem(
                    t("sideBar.items.column20"),
                    'marker_mobile_item',
                    <Link to='/devices/marker-mobile'>
                        <Smartphone size={14} color='#1e1e1e'/>
                    </Link>
                ),
            ]),
            getItem(t('sideBar.items.column4'), 'payments_items', <HistoryOutlined/>, [
                getItem(
                    t('sideBar.items.column5'),
                    'log_payments_items',
                    <Link to='/payments/logs'>
                        <CreditCardOutlined/>
                    </Link>
                ),
                getItem(
                    t('sideBar.items.column6'),
                    'sms_payments_items',
                    <Link to='/payments/sms'>
                        <MessageOutlined/>
                    </Link>
                ),
                getItem(
                    t('sideBar.items.column7'),
                    'email_payments_items',
                    <Link to='/email/list'>
                        <MailOutlined/>
                    </Link>
                ),
            ]),
            getItem('Scan2Pay', 'scan2pay', <MonitorSmartphone size={14} color='#1e1e1e'/>, [
                getItem('Logs', 'scan2pay_payments', <HistoryOutlined/>, [
                    getItem(
                        'PayMe',
                        's2p_payme_logs',
                        <Link to='/s2p/payme/logs'>
                            <CreditCardOutlined/>
                        </Link>
                    ),
                    getItem(
                        'Click',
                        's2p_click_logs',
                        <Link to='/s2p/click/logs'>
                            <CreditCardOutlined/>
                        </Link>
                    ),
                    getItem(
                        'Uzum',
                        's2p_uzum_logs',
                        <Link to='/s2p/uzum/logs'>
                            <CreditCardOutlined/>
                        </Link>
                    ),
                ]),
                getItem(
                    t('sideBar.items.column16'),
                    's2p_staff',
                    <Link to='/s2p/staffs'>
                        <Users size={14} color='#1e1e1e'/>
                    </Link>
                ),
                getItem(
                    t('sideBar.items.column17'),
                    's2p_tips',
                    <Link to='/s2p/tips'>
                        <CircleArrowDown size={14} color='#1e1e1e'/>
                    </Link>
                ),
            ]),
            getItem(t('sideBar.items.column8'), 'orders_orders_item', <FileDoneOutlined/>, [
                getItem(
                    t('sideBar.items.column11'),
                    'orders_sale_item',
                    <Link to='/orders/sale'>
                        <FilePlus2 size={14} color='#1e1e1e'/>
                    </Link>
                ),
                getItem(
                    t('sideBar.items.column12'),
                    'orders_refund_item',
                    <Link to='/orders/refund'>
                        <FileMinus2 size={14} color='#1e1e1e'/>
                    </Link>
                ),
                getItem(
                    t('sideBar.items.column13'),
                    'orders_credit_item',
                    <Link to='/orders/credit'>
                        <Handshake size={14} color='#1e1e1e'/>
                    </Link>
                ),
                getItem(
                    t('sideBar.items.column14'),
                    'orders_prepaid_item',
                    <Link to='/orders/prepaid'>
                        <CalendarPlus size={14} color='#1e1e1e'/>
                    </Link>
                ),
            ]),
            getItem(t('sideBar.items.column9'), 'devices_versions_item', <ClusterOutlined/>, [
                getItem(
                    t('sideBar.items.column18'),
                    'fbox_item',
                    <Link to='/devices/version'>
                        <Box size={14} color='#1e1e1e'/>
                    </Link>
                ),
                getItem(
                    t('sideBar.items.column19'),
                    'fme_item',
                    <Link to='/devices/fiscal-me/version'>
                        <LaptopMinimal size={14} color='#1e1e1e'/>
                    </Link>
                ),
            ]),
            getItem(
                'Fbox Wikipedia',
                'fbox_wikipedia',
                <Link to='/wikipedia'>
                    <BookOpen size={14} color='#3b3b3b'/>
                </Link>
            ),
        ]
    )
}

export default AdminSideBarItems;

